import React from 'react';
import {
  TubeIcon,
  CateringIcon,
} from '../icons';
import { ReactComponent as MagicStarIcon } from '../icons/magic-star-icon.svg';
const VenueHeader = ({ venue, calculateDistance, reviewCount = null }) => {
  return (
    <>
      <div className="md:mb-4 mb-8 venue-header-section">
        <div className="flex flex-col gap-8 w-full overflow-visible">
          <div className="vd-title-block">
            <div className="vd-name-row">
              <h1 className="venue-name-header md:text-5xl text-3xl font-medium break-words">{venue.name || 'Venue Name'}</h1>
              <div className="vd-rating">
                <MagicStarIcon width="20" height="20" />
                {reviewCount === 0 ? (
                  <span className="vd-rating-count">No reviews yet</span>
                ) : (
                  <>
                    {venue.rating ? <span>{venue.rating}</span> : null}
                    {reviewCount != null ? <span className="vd-rating-count">({reviewCount})</span> : null}
                  </>
                )}
              </div>
            </div>
            <div className="venue-stats">
              <div className="stat-item">
                <img
                  className="vd-location-icon"
                  src="/manual-booking/icons/pending-guests.png"
                  alt=""
                  aria-hidden="true"
                  width="20"
                  height="20"
                />
                <span>{venue.maxCapacity || 20} guests</span>
              </div>
              <span className="stat-separator">•</span>
              <div className="stat-item">
                <CateringIcon width="20" height="20" />
                <span>In-house catering</span>
              </div>
            </div>

            <div className="vd-location flex md:flex-row flex-col gap-2 md:items-center items-start">
              <div className="flex flex-row gap-2 items-center">
                <img
                  className="vd-location-icon"
                  src="/manual-booking/icons/pending-location.png"
                  alt=""
                  aria-hidden="true"
                  width="20"
                  height="20"
                />
                <span className='max-w-xl line-clamp-2'>
                  {venue.address || venue.area || 'Address not available'}
                </span>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <span className="vd-location-dot md:block hidden">•</span>
                <TubeIcon width="20" height="20" />
                <span>{calculateDistance(venue)}</span>
              </div>
            </div>
            {venue.vibes && venue.vibes.length > 0 && (
              <div className="vd-tags flex flex-wrap flex-row">
                {venue.vibes.map((tag, index) => (
                  <span
                    key={index}
                    className="vd-tag"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}
          </div>

        </div>

        
      </div>
    </>
  );
};

export default VenueHeader;

